/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import Responsive from 'app/components/responsive/Responsive';

type Props = {
  ad: Object,
  width?: number,
  height?: number,
  showAdHint?: boolean,
};

const defaultProps = {
  width: undefined,
  height: undefined,
  showAdHint: false,
};

const AdImageWrapper = glamorous.div(
  () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  ({ width, height }) => (width && height ? {
    width,
    height,
  } : {}),
);

const AdImage = glamorous.img({
  height: 'auto',
  width: '100%',
});

const AdHint = glamorous.div(({ theme }) => ({
  fontSize: theme.spacing.small,
  '&::before': {
    content: 'Advertisement',
  },
}));

const HiddenImage = glamorous.img({
  position: 'absolute',
  visibility: 'hidden',
  width: 0,
  height: 0,
  border: 0,
});

function AdImageLink({
  ad,
  width,
  height,
  showAdHint,
}: Props) {
  const {
    desktopLink,
    desktopHiddenImageSrc,
    desktopImageSrc,
    mobileLink,
    mobileImageSrc,
    mobileHiddenImageSrc,
  } = ad;

  return (
    <AdImageWrapper width={width} height={height}>
      {showAdHint && <AdHint />}
      <Responsive tabletPortrait desktop>
        {(isLargeScreen) => {
          if (!isLargeScreen && !mobileImageSrc) {
            return null;
          }
          return (
            <React.Fragment>
              <a href={isLargeScreen ? desktopLink : mobileLink} target="_blank" rel="noopener noreferrer">
                <AdImage src={isLargeScreen ? desktopImageSrc : mobileImageSrc} />
              </a>
              <HiddenImage src={isLargeScreen ? desktopHiddenImageSrc : mobileHiddenImageSrc} />
            </React.Fragment>
          );
        }}
      </Responsive>
    </AdImageWrapper>
  );
}

AdImageLink.defaultProps = defaultProps;

export default React.memo(AdImageLink);
